module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component.css
// module id = ./src/app/Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component.css
// module chunks = main